import { Injectable } from '@angular/core';
import { Action, State, StateContext, Selector, Select } from '@ngxs/store';
import { catchError, debounceTime, switchMap, take, tap } from 'rxjs/operators';
import {
  FetchAllFamilyMembers,
  // FetchFamilyMember,
  SetSelectedPatient,
  AddFamilyMember,
  UpdateFamilyMember,
  UpdatePharmacy,
  ClearFamilyMemberResponse,
  ClearFamilyMembers,
  DeleteFamilyMember,
  UpdateKeycloakUserAndFamilyMember,
} from '../actions/family-member.action';
import { FamilyMemberService } from '../services/family-member.service';
import {
  FamilyMemberDetails,
  FamilyMemberResponse,
} from '../interfaces/family-member.interface';
import { Store } from '@ngxs/store';
import { UserAuthState } from './user-auth.state';
import {
  ClearKeycloakStatus,
  ClearLoginDetals,
  FetchPatientDeleteRequests,
  UpdateKeycloakUser,
} from '../actions';
import { Router } from '@angular/router';
import { CommonState } from './common.state';
import { EMPTY, Observable } from 'rxjs';

export class FamilyMemberStateModel {
  familymembers: FamilyMemberDetails[];
  familymemberResponse: FamilyMemberResponse;
  selectedPatient: any;
  updatePharmacyStatus: any
}
@State<FamilyMemberStateModel>({
  name: 'familyMembers',
  defaults: {
    selectedPatient: undefined,
    updatePharmacyStatus: undefined,
    familymembers: [],
    familymemberResponse: {
      errorMessage: undefined,
      statusCode: 0,
      patientId: undefined,
    },
  },
})
@Injectable()
export class FamilyMemberState {

  @Select(CommonState.getKeycloakUpdate) keycloakUpdate$: Observable<any>;
  
  constructor(
    private familyMemberService: FamilyMemberService,
    private store: Store,
    public router: Router
  ) {}

  @Selector()
  static getFamilyMemberDetails(state: FamilyMemberStateModel) {
    return state.familymembers;
  }
  @Selector()
  static getfamilyMemberResponse(state: FamilyMemberStateModel) {
    return state.familymemberResponse;
  }

  @Selector()
  static getUpdatePharmacyStatus(state: FamilyMemberStateModel) {
    return state.updatePharmacyStatus;
  }

  @Selector()
  static getSelectedPatient(state: FamilyMemberStateModel) {
    return state.selectedPatient;
  }

  @Action(ClearFamilyMemberResponse)
  ClearfamilyMemberResponse({
    patchState,
  }: StateContext<FamilyMemberStateModel>) {
    patchState({
      familymemberResponse: {
        errorMessage: undefined,
        statusCode: 0,
        patientId: undefined,
      },
    });
  }

  @Action(SetSelectedPatient)
  SetSelectedPatient(
    { patchState }: StateContext<FamilyMemberStateModel>,
    { payload }: any
  ) {
    patchState({
      selectedPatient: payload,
    });
  }

  @Action(FetchAllFamilyMembers)
  FetchAllFamilyMembers({ patchState }: StateContext<FamilyMemberStateModel>) {
    const loginInfo = this.store.selectSnapshot(
      UserAuthState.getUserAuthDetails
    );
    if (loginInfo && loginInfo.token && loginInfo.patientId) {
      return this.familyMemberService
        .getFamilyMembers(loginInfo.token, loginInfo?.patientId)
        .pipe(
          debounceTime(1000),
          tap((response: any) => {
            if (response && response.statusCode) {
              if (response.statusCode == 200) {
                if (response.data) {
                  // response.data.isNewPaientQuestonnaireCompleted = response.data
                  //   .newPaientQuestonnaire
                  //   ? true
                  //   : false;
                  if (
                    !response.data ||
                    (response.data && response.data.length == 0)
                  ) {
                    this.store.dispatch(new ClearLoginDetals());
                    const pwa = localStorage.getItem('hideInstall');
                    localStorage.clear();
                    if (pwa) localStorage.setItem('hideInstall', pwa);
                    this.router.navigate(['/']);
                  }

                  patchState({
                    familymembers: response.data,
                  });
                  if (response.data.length > 0) {
                  }
                  return;
                }
              }
              patchState({
                familymembers: [],
              });
            }
          })
        );
    }
  }

  @Action(AddFamilyMember)
  AddFamilyMember(
    { patchState }: StateContext<FamilyMemberStateModel>,
    { payload }: AddFamilyMember
  ) {
    const loginInfo = this.store.selectSnapshot(
      UserAuthState.getUserAuthDetails
    );
    if (loginInfo && loginInfo.token) {
      return this.familyMemberService
        .postFamilyMember(payload, loginInfo.token)
        .pipe(
          tap((response: any) => {
            if (response && response.statusCode) {
              if (response.statusCode == 200) {
                if (response.data) {
                  patchState({
                    familymemberResponse: {
                      statusCode: 200,
                      patientId: response.data.patientId,
                      errorMessage: undefined,
                    },
                    selectedPatient: response.data,
                  });
                }
              } else {
                patchState({
                  familymemberResponse: {
                    statusCode: response.statusCode,
                    patientId: '',
                    errorMessage: response.message ? response.message : 'Error',
                  },
                });
              }
            } else {
              patchState({
                familymemberResponse: {
                  statusCode: 0,
                  errorMessage: undefined,
                  patientId: undefined,
                },
              });
            }
          })
        );
    }
  }


  @Action(UpdateKeycloakUserAndFamilyMember)
  UpdateKeycloakUserAndFamilyMember(
    { patchState }: StateContext<FamilyMemberStateModel>,
    { payload }: UpdateKeycloakUserAndFamilyMember
  ) {
    const loginInfo = this.store.selectSnapshot(UserAuthState.getUserAuthDetails);

    if (loginInfo?.token) {
      const selectedPatient: any = this.store.selectSnapshot(FamilyMemberState.getSelectedPatient); 

      const userData = selectedPatient?.patientId === payload.patientId && selectedPatient.userId
        ? {
          id: selectedPatient.userId,
          obj: {
            firstName: payload.firstName,
            lastName: payload.lastName,
            email: payload.email,
            username: payload.email,
          },
        }
        : payload.userId
          ? {
            id: payload.userId,
            obj: {
              firstName: payload.firstName,
              lastName: payload.lastName,
              email: payload.email,
              username: payload.email,
            },
          }
          : null;

      if (userData) {
        this.store.dispatch(new ClearKeycloakStatus());

        return this.store.dispatch(new UpdateKeycloakUser(userData)).pipe(
          switchMap(() => this.keycloakUpdate$),
          take(1),
          switchMap((keycloakUpdateRes) => {
            if (keycloakUpdateRes.statusCode == 200) {
              return this.familyMemberService
                .patchFamilyMember({ ...payload, userIdOnAction: loginInfo.userId }, loginInfo.token)
                .pipe(
                  tap((response: any) => {
                    if (response && response.statusCode){
                    const updatedState = response?.statusCode === 200 && response.data
                      ? {
                        familymemberResponse: {
                          statusCode: 200,
                          errorMessage: undefined,
                          patientId: undefined,
                        },
                      }
                      : {
                        familymemberResponse: {
                          patientId: undefined,
                          statusCode: response?.statusCode,
                          errorMessage: response?.message || 'Error',
                        },
                      };

                    patchState(updatedState);

                    if (response?.statusCode === 200) {
                      this.store.dispatch(new FetchAllFamilyMembers());
                    }
                    }else{
                      patchState({
                        familymemberResponse: {
                          statusCode: 0,
                          errorMessage: undefined,
                          patientId: undefined,
                        },
                      });
                    }
                  })
                );
            }else if (keycloakUpdateRes.statusCode){
              patchState({
                familymemberResponse: {
                  statusCode: keycloakUpdateRes?.statusCode,
                  errorMessage: keycloakUpdateRes?.message || 'Error',
                  patientId: undefined,
                },
              });
            }else{
              patchState({
                familymemberResponse: {
                  statusCode: 0,
                  errorMessage: undefined,
                  patientId: undefined,
                },
              });
            }
            patchState({
              familymemberResponse: {
                statusCode: 0,
                errorMessage: undefined,
                patientId: undefined,
              },
            });
          })
        );
      } else if (payload?.patientId) {
        // If userData is null but payload has patientId, proceed with patchFamilyMember
        return this.familyMemberService
          .patchFamilyMember({ ...payload, userIdOnAction: loginInfo.userId }, loginInfo.token)
          .pipe(
            tap((response: any) => {
              if (response && response.statusCode) {
                const updatedState = response?.statusCode === 200 && response.data
                  ? {
                    familymemberResponse: {
                      statusCode: 200,
                      errorMessage: undefined,
                      patientId: undefined,
                    },
                  }
                  : {
                    familymemberResponse: {
                      patientId: undefined,
                      statusCode: response?.statusCode,
                      errorMessage: response?.message || 'Error',
                    },
                  };

                patchState(updatedState);

                if (response?.statusCode === 200) {
                  this.store.dispatch(new FetchAllFamilyMembers());
                }
              } else {
                patchState({
                  familymemberResponse: {
                    statusCode: 0,
                    errorMessage: undefined,
                    patientId: undefined,
                  },
                });
              }
            })
          );
      } else {
        patchState({
          familymemberResponse: {
            statusCode: 0,
            errorMessage: undefined,
            patientId: undefined,
          },
        });
      }
    }
  }


  @Action(UpdateFamilyMember)
  UpdateFamilyMember(
    { patchState }: StateContext<FamilyMemberStateModel>,
    { payload }: UpdateFamilyMember
  ) {
    const loginInfo = this.store.selectSnapshot(
      UserAuthState.getUserAuthDetails
    );
    if (loginInfo && loginInfo.token) {
      return this.familyMemberService
        .patchFamilyMember({ ...payload, userIdOnAction: loginInfo.userId }, loginInfo.token)
        .pipe(
          tap((response: any) => {
            if (response && response.statusCode) {
              if (response.statusCode == 200) {
                const selectedPatient: any = this.store.selectSnapshot(
                  FamilyMemberState.getSelectedPatient
                );
                if (
                  selectedPatient &&
                  selectedPatient.patientId == payload.patientId &&
                  selectedPatient.userId
                ) {
                  const userData = {
                    id: selectedPatient.userId,
                    obj: {
                      firstName: payload.firstName,
                      lastName: payload.lastName,
                      email: payload.email,
                      username: payload.email,
                    },
                  };
                  this.store.dispatch(new ClearKeycloakStatus());
                  this.store.dispatch(new UpdateKeycloakUser(userData));
                } else if (payload.userId) {
                  const userData = {
                    id: payload.userId,
                    obj: {
                      firstName: payload.firstName,
                      lastName: payload.lastName,
                      email: payload.email,
                      username: payload.email,
                    },
                  };
                  this.store.dispatch(new ClearKeycloakStatus());
                  this.store.dispatch(new UpdateKeycloakUser(userData));
                }

                if (response.data) {
                  patchState({
                    familymemberResponse: {
                      statusCode: 200,
                      errorMessage: undefined,
                      patientId: undefined,
                    },
                  });

                  this.store.dispatch(new FetchAllFamilyMembers());
                }
              } else {
                patchState({
                  familymemberResponse: {
                    patientId: undefined,
                    statusCode: response.statusCode,
                    errorMessage: response.message ? response.message : 'Error',
                  },
                });
              }
            } else {
              patchState({
                familymemberResponse: {
                  statusCode: 0,
                  errorMessage: undefined,
                  patientId: undefined,
                },
              });
            }
          })
        );
    }
  }

  @Action(ClearFamilyMembers)
  clearFamily({ patchState }: StateContext<FamilyMemberStateModel>) {
    patchState({
      familymembers: undefined,
      familymemberResponse: undefined,
      selectedPatient: undefined,
    });
  }

  @Action(UpdatePharmacy)
  UpdatePharmacy(
    { patchState }: StateContext<FamilyMemberStateModel>,
    { payload }: UpdatePharmacy
  ) {
    const loginInfo = this.store.selectSnapshot(
      UserAuthState.getUserAuthDetails
    );
    if (loginInfo && loginInfo.token) {
      return this.familyMemberService
        .updatePharmacy(payload, loginInfo.token)
        .pipe(
          tap((response: any) => {
            if (response && response.statusCode) {
              if(response.statusCode == 200){
                patchState({
                  updatePharmacyStatus : response.data
                });
              }else{
                patchState({
                  updatePharmacyStatus : undefined
                });
              }
            }else{
              patchState({
                updatePharmacyStatus : undefined
              });
            }
          })
        );
    }
  }

  @Action(DeleteFamilyMember)
  DeleteFamilyMember(
    { patchState }: StateContext<FamilyMemberStateModel>,
    { payload }: any
  ) {
    const loginInfo = this.store.selectSnapshot(
      UserAuthState.getUserAuthDetails
    );
    if (loginInfo && loginInfo.token) {
      return this.familyMemberService
        .deleteFamilyMember(payload, loginInfo.token)
        .pipe(
          tap((response: any) => {
            if (response && response.statusCode == 200) {
              this.store.dispatch(new FetchPatientDeleteRequests());
            }
          })
        );
    }
  }
}
